import {
  HandRaiseIcon
} from "./chunk-TGAU4U7N.mjs";
export {
  HandRaiseIcon
};
